export default __webpack_public_path__ + "static/media/sand-blast.55a9762c.png";